module.exports = __webpack_public_path__ + "img/onboarding-step-9.04aa28a5.png";